// extracted by mini-css-extract-plugin
export default {"features":"styles_features__3SbFh","features__row":"styles_features__row__n+Oox"};